export const app = {
  name: "QRBite",
  domain: "qrbite.co",
  apiUrl: `https://${import.meta.env.VITE_SUPABSE_PROJECT_ID}.supabase.co`,
  workerUrl: import.meta.env.DEV
    ? `http://${import.meta.env.VITE_WORKER_DOMAIN}`
    : `https://${import.meta.env.VITE_WORKER_DOMAIN}`,
  enableMocking: false,
};
